// @ts-nocheck
/**
 * AI Insight Mock Data - 50+ AI-generated insights
 */

import { generateAiInsights } from './helpers';

// Generate 60 AI insights
export const mockAiInsights = generateAiInsights(60);

// Categorized insights
export const mockTrendInsights = mockAiInsights.filter((i) => i.category === 'trend');
export const mockAnomalyInsights = mockAiInsights.filter((i) => i.category === 'anomaly');
export const mockRecommendationInsights = mockAiInsights.filter((i) => i.category === 'recommendation');
export const mockForecastInsights = mockAiInsights.filter((i) => i.category === 'forecast');

// High confidence insights (>= 0.8)
export const mockHighConfidenceInsights = mockAiInsights.filter((i) => (i.confidence || 0) >= 0.8);

// Recent insights (last 24 hours)
export const mockRecentInsights = mockAiInsights.filter((i) => {
  const hoursSince = (new Date().getTime() - i.timestamp.getTime()) / (1000 * 60 * 60);
  return hoursSince < 24;
});
